import { Inject, Injectable, Optional } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { OVERLAY_ROOT_TOKEN } from '@client/mfe/tokens/mfe-tokens';

@Injectable()
export class ShadowOverlayContainer extends OverlayContainer {
    constructor (
        @Optional() @Inject(OVERLAY_ROOT_TOKEN) private readonly overlayRoot: HTMLElement | null,
    ) {
        super();
    }

    protected override _createContainer (): void {
        super._createContainer();

        if (this.overlayRoot && this._containerElement) {
            this.overlayRoot.appendChild(this._containerElement);
        }
    }
}
